import React from "react";
import { Layout, Menu } from "antd";
import logo from "../../assets/logo.svg";
import { useMsal } from "@azure/msal-react";
import LogoutIcon from "@mui/icons-material/Logout";

const { Header } = Layout;

const NavBar = () => {
  const { instance } = useMsal();
  const name = instance.getActiveAccount()?.name?.split(" ");
  const label = name?.length > 1 ? `${name[0][0]}${name[1][0]}` : name[0][0];

  return (
    <Layout>
      <Header
        style={{
          backgroundColor: "#1967d2",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div
          className="logo"
          style={{
            color: "white",
            fontSize: "18px",
            fontWeight: "bold",
            marginRight: "20px",
          }}
        >
          <img
            src={logo}
            width={70}
            height={70}
            alt="Logo"
            style={{ margin: "0px", display: "inline" }}
          />
          DOCUMENTOR AI
        </div>
        <Menu
          theme="dark"
          mode="horizontal"
          defaultSelectedKeys={["home"]}
          style={{ backgroundColor: "#1a1a1a", flex: 1, minWidth: 0 }}
          items={[]}
        />
        <div
          style={{
            color: "#fff",
            fontWeight: "bold",
            height: 40,
            width: 40,
            borderRadius: 20,
            background: "rgba(59, 90, 134, 1)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
          title={name.join(" ")}
        >
          {label}
        </div>
        <div
          title="logout"
          style={{ cursor: "pointer" }}
          onClick={() => {
            instance.logoutRedirect().catch((error) => console.log(error));
          }}
        >
          <LogoutIcon style={{ color: "#fff", marginLeft: 10 }} />
        </div>
      </Header>
    </Layout>
  );
};

export default NavBar;
